module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/public-sdk/~/core-js/modules/_library.js
// module id = 25
// module chunks = 0